import { InputInterface } from './Exa_Input'

export enum TypePartie {
    TYPE_MANUEL = 1,
    TYPE_AUTO = 2
}

interface TypePartieSpec {
    index: number;
    libelle: string;
}

export function getTypePartieSpec(typeInput: TypePartie): TypePartieSpec {
    switch (typeInput) {
        case TypePartie.TYPE_MANUEL:
            return { index: 1, libelle: 'Partie editable' }
        case TypePartie.TYPE_AUTO:
            return { index: 2, libelle: 'Partie automatique' }
        default:
            return { index: 1, libelle: 'Partie editable' }
    }
}

export interface PartieFormulaireInterface
{
    id: number | 0;
    libelle: string;
    ref: string;
    ordre: number | 0;
    inputs: Array<InputInterface> | [];
    inputSelect?: InputInterface | null;
    json?: string | '';
    jsonValues?: string | '';
    tempInputId?: number | null;
    condition: any | null;
    description: string;
    type: TypePartie;
    data: any | null;
    value: any | null;
    anomalie?: string | null;
}
